import type { SxProps, Theme } from "@mui/material/styles";

/** Standard horizontal padding for full-width app pages. */
export const pagePaddingSx: SxProps<Theme> = {
  p: { xs: 2, sm: 3 },
};
